<template>
  <a-config-provider :autoInsertSpaceInButton="true">
    <a-locale-provider :locale="locale">
      <div id="app" class="App.vue">
        <router-view />

        <j-modal
          title="文件预览"
          size="normal"
          :visible="visible"
          :centered="true"
          @cancel="handleCancel"
          dialogClass="resize-for-mobile"
          wrapClassName="a-modal-no-padding a-modal-preview"
        >
          <template slot="footer"
            ><a-button @click="handleCancel" type="primary" icon="close">关闭</a-button>
          </template>

          <a-spin :spinning="loading">
            <iframe
              id="previewFrame"
              :src="this.previewURL"
              width="100%"
              height="100%"
              frameborder="0"
              scrolling="no"
              @load="loading = false"
            ></iframe>
          </a-spin>
        </j-modal>

        <j-modal
          :width="500"
          :visible="wsVisible"
          :closable="true"
          @cancel="wsVisible = false"
          :maskClosable="false"
          :footer="null"
          :centered="true"
        >
          <div class="ws-message-wrapper">
            <div class="ws-message-title">
              <a-icon type="mail" theme="twoTone" class="animate__animated animate__flipInX animate__delay-0.5s" />
              <div>您收到一条系统消息：</div>
            </div>

            <div v-html="wsMessage" class="ws-message-content"></div>

            <div><a-button type="primary" @click="wsVisible = false">我知道了</a-button></div>
          </div>
        </j-modal>

        <div class="primaryColorValue1" style="background-color: var(--color-primary-1)"></div>
        <div class="primaryColorValue2" style="background-color: var(--color-primary-2)"></div>
        <div class="primaryColorValue3" style="background-color: var(--color-primary-3)"></div>
        <div class="primaryColorValue4" style="background-color: var(--color-primary-4)"></div>
        <div class="primaryColorValue5" style="background-color: var(--color-primary-5)"></div>
        <div class="primaryColorValue6" style="background-color: var(--color-primary-6)"></div>

        <div class="primary1ColorValue1" style="background-color: var(--color-primary1-1)"></div>
        <div class="primary1ColorValue2" style="background-color: var(--color-primary1-2)"></div>
        <div class="primary1ColorValue3" style="background-color: var(--color-primary1-3)"></div>
        <div class="primary1ColorValue4" style="background-color: var(--color-primary1-4)"></div>
        <div class="primary1ColorValue5" style="background-color: var(--color-primary1-5)"></div>
        <div class="primary1ColorValue6" style="background-color: var(--color-primary1-6)"></div>

        <div class="primary2ColorValue1" style="background-color: var(--color-primary2-1)"></div>
        <div class="primary2ColorValue2" style="background-color: var(--color-primary2-2)"></div>
        <div class="primary2ColorValue3" style="background-color: var(--color-primary2-3)"></div>
        <div class="primary2ColorValue4" style="background-color: var(--color-primary2-4)"></div>
        <div class="primary2ColorValue5" style="background-color: var(--color-primary2-5)"></div>
        <div class="primary2ColorValue6" style="background-color: var(--color-primary2-6)"></div>

        <div class="primary3ColorValue1" style="background-color: var(--color-primary3-1)"></div>
        <div class="primary3ColorValue2" style="background-color: var(--color-primary3-2)"></div>
        <div class="primary3ColorValue3" style="background-color: var(--color-primary3-3)"></div>
        <div class="primary3ColorValue4" style="background-color: var(--color-primary3-4)"></div>
        <div class="primary3ColorValue5" style="background-color: var(--color-primary3-5)"></div>
        <div class="primary3ColorValue6" style="background-color: var(--color-primary3-6)"></div>

        <div class="primary4ColorValue1" style="background-color: var(--color-primary4-1)"></div>
        <div class="primary4ColorValue2" style="background-color: var(--color-primary4-2)"></div>
        <div class="primary4ColorValue3" style="background-color: var(--color-primary4-3)"></div>
        <div class="primary4ColorValue4" style="background-color: var(--color-primary4-4)"></div>
        <div class="primary4ColorValue5" style="background-color: var(--color-primary4-5)"></div>
        <div class="primary4ColorValue6" style="background-color: var(--color-primary4-6)"></div>

        <div class="greenColorValue4" style="background-color: var(--color-green-4)"></div>
        <div class="greenColorValue5" style="background-color: var(--color-green-5)"></div>

        <div class="redColorValue4" style="background-color: var(--color-red-4)"></div>
        <div class="redColorValue5" style="background-color: var(--color-red-5)"></div>
      </div>
    </a-locale-provider>
  </a-config-provider>
</template>
<script>
import Vue from 'vue'
import Storage from 'vue-ls'
import config from '@/defaultSettings'
import enquireScreen from '@/utils/device'
import store from './store/'
import { putAction, postAction, getAction } from '@/api/manage'
const ja_JP = antd.locales.ja_JP
Vue.use(Storage, config.storageOptions)

//import { DEFAULT_ICON_CONFIGS } from '@icon-park/vue'
//const IconConfig = {
//  ...DEFAULT_ICON_CONFIGS,
//  //size: 20,
//  strokeWidth: 3,
//  theme: 'multi-color',
//  colors: {
//    multiColor: {
//      outFillColor: '#91d5ff',
//      innerFillColor: '#e6f7ff',
//    },
//  },
//}

export default {
  components: {
    WebSocket,
  },
  data() {
    return {
      locale: ja_JP,
      visible: false,
      ws: null,
      wsVisible: false,
      wsMessage: '',
      loading: false,
      previewURL: '',
    }
  },
  provide() {
    return {
      changeAppLocale: this.changeAppLocale,
      preview: this.preview,
      wsReceived: this.wsReceived,
      //ICON_CONFIGS: IconConfig,
    }
  },
  created() {
    //window.addEventListener('message', function (msg) {
    //  if (msg.data && typeof msg.data == 'string' && msg.data.indexOf('previewFrame:') >= 0) {
    //    var height = Number(msg.data.split(':')[1])

    //    var iframe = document.getElementById('previewFrame')
    //    iframe.height = height
    //  }
    //})

    if (Vue.ls.get('Locale') != 'ja_JP') {
      this.changeAppLocale(Vue.ls.get('Locale'))
    }

    let that = this
    enquireScreen((deviceType) => {
      // tablet
      if (deviceType === 0) {
        that.$store.commit('TOGGLE_DEVICE', 'mobile')
        that.$store.dispatch('setSidebar', false)
        document.body.classList.add('mobile')
      }
      // mobile
      else if (deviceType === 1) {
        that.$store.commit('TOGGLE_DEVICE', 'mobile')
        that.$store.dispatch('setSidebar', false)
        document.body.classList.add('mobile')
      } else {
        that.$store.commit('TOGGLE_DEVICE', 'desktop')
        that.$store.dispatch('setSidebar', true)
        document.body.classList.remove('mobile')
      }
    })
  },
  mounted() {},
  destroyed() {},
  methods: {
    preview(filePath) {
      this.loading = true

      if (filePath.indexOf(window._CONFIG['staticDomainURL']) >= 0) {
        var finalURL = filePath
      } else {
        var originwURL = filePath.replaceAll('\\', '/')
        var finalURL = window._CONFIG['staticDomainURL'] + '/' + originwURL
      }

      // finalURL = finalURL.replaceAll(host, 'http://127.0.0.1')

      this.previewURL = window._CONFIG['previewURL'] + encodeURIComponent(Base64.encode(finalURL))
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    changeAppLocale(lang) {
      this.locale = eval('antd.locales.' + lang)

      this.$i18n.locale = lang
      Vue.ls.set('Locale', lang)

      window.locales.forEach((element) => {
        document.body.classList.remove(element.value)
      })
      document.body.classList.add(lang)

      antd.Modal.props.okText.default = this.$t('disp.btn.confirm')
      antd.Popconfirm.props.okText.default = this.$t('disp.btn.confirm')
    },
    wsReceived(wsMessage) {
      this.wsMessage = wsMessage
      this.wsVisible = true
    },
  },
}
</script>
<style lang="less">
#previewFrame {
  display: block;
  height: calc(100vh - 116px);
}

.a-modal-preview {
  z-index: 9999999 !important;
}
</style>

<style lang="less" scoped>
.ws-message-wrapper {
  display: flex;
  flex-direction: column;

  .ws-message-title {
    font-size: 16px;
    display: flex;
    align-items: center;

    i {
      font-size: 30px;
      margin-right: 20px;
      filter: drop-shadow(3px 4px 0px #eee);
    }
  }

  .ws-message-content {
    font-size: 16px;
    border-top: 2px solid #f3f3f3;
    margin-top: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    white-space: pre-wrap;
  }

  .ant-btn {
    margin-bottom: 0;
    float: right;
  }
}
</style>
